import { Buttons, FlexContainer, Notification, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { showChat } from 'Services/chat';
import { history } from 'Store';
import useTranslation from 'Hooks/useTranslation';
import CustomTransition from 'Components/CustomTransition';
import { routes } from 'Constants/routes';
import { AccountDeleteProp } from '../AccountPrivacy/components/AccountDelete/types';
import * as Styled from './styles';

const AccountDeleteInfo = ({ setScreen }: AccountDeleteProp): JSX.Element => {
  const { t } = useTranslation(locizeNS.ACCOUNT);

  return (
    <CustomTransition start>
      <FlexContainer direction="column">
        <Text type="fds_heading_bold_H5" align="center" color="dark_500">
          {t('Account.delete.title')}
        </Text>
        <Text align="start" type="fds_paragraph_medium_M" color="dark_500" mt="fds_size_32">
          {t('Account.delete.subtitle')}
        </Text>
        <Styled.List>
          {[...Array(3).keys()].map(index => (
            <li key={index}>{t(`Account.delete.${index}`)}</li>
          ))}
        </Styled.List>
        <Notification
          buttonLabel={t('Account.delete.helpButton')}
          buttonOnClick={showChat}
          description={t('Account.delete.notification.description')}
          id="warning"
          mode="warning"
          noClose
          title=""
          mt="fds_size_24"
        />
        <FlexContainer mt="fds_size_32" gap="dimension_08">
          <Buttons.Classic
            size="s"
            mode="secondary"
            label={t('Account.delete.button.continue')}
            onClick={() => {
              setScreen(3);
              history.replace(routes.ACCOUNT_DELETE_FORM);
            }}
          />
          <Buttons.Classic
            size="s"
            mode="success"
            label={t('Account.delete.button.cancel')}
            onClick={() => {
              setScreen(1);
              history.replace(routes.ACCOUNT);
            }}
          />
        </FlexContainer>
      </FlexContainer>
    </CustomTransition>
  );
};

export default AccountDeleteInfo;
